import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from '../../components/dialogs/dialog-confirmation/dialog-confirm.component';
import {
  DialogWorkScheduleBulkComponent,
  DialogWorkScheduleBulkData
} from '../../components/dialogs/dialog-work-schedule-bulk/dialog-work-schedule-bulk.component';
import {
  DialogRepeatPatternComponent,
  DialogRepeatPatternData
} from '../../components/dialogs/dialog-repeat-pattern/dialog-repeat-pattern.component';
import {
  DialogAssignRotationComponent,
  DialogAssignRotationData
} from '../../components/dialogs/dialog-assign-rotation/dialog-assign-rotation.component';
import { DialogImageOrVideoComponent } from '../../components/dialogs/dialog-image-video/dialog-image-video.component';
import {
  SurveySymptomsValidateAds,
  PersonalInfo,
  ModelDocumentsShow,
  CardList,
  Poll,
  OptionsCardSelect,
  PayrollConfiguration,
  WorkShiftConfiguration,
  ExtractedDocumentResponse
} from '../../interfaces/interfaces';
import { DialogSelectPersonalCompanyInfoId } from '../../components/dialogs/dialogs-encuesta/dialog-personal-company-infoid/dialog-personal-company-infoid.component';
import { DialogOkComponent } from '../../components/dialogs/dialogs-encuesta/dialog-ok/dialog-ok.component';
import { DialogCondicionesComponent } from '../../components/dialogs/dialogs-condicionesServicios/dialog-condiciones/dialog-condiciones.component';
import { CompanyModel } from '../../models/CompanyModel';
import { DialogPrintPreCarnetComponent } from '../../components/dialogs/dialog-print-pre-carnet/dialog-print-pre-carnet.component';
import { DialogAdminAccesoComponent } from '../../components/dialogs/dialog-admin-acceso/dialog-admin-acceso.component';
import { DialogGestorImgComponent } from '../../components/dialogs/dialog-gestor-img/dialog-gestor-img.component';
import { TypeAdminAcceso } from './utils.types';
import {
  DialogContratoIndividualComponent
} from '../../components/dialogs/dialog-contrato-individual/dialog-contrato-individual.component';
import { DialogCreatePersonalComponent } from '../../components/dialogs/dialog-create-personal/dialog-create-personal.component';
import { DialogIndividualContractAprovedComponent } from '../../components/dialogs/dialog-individual-contract-aproved/dialog-individual-contract-aproved.component';
import { DialogSearchEmployerComponent } from '../../components/dialogs/dialog-search-employer/dialog-search-employer.component';
import { DialogCreateEmployerComponent } from '../../components/dialogs/dialog-create-employer/dialog-create-employer.component';
import { DialogCreateNoveltyComponent } from '../../components/dialogs/dialog-create-novelty/dialog-create-novelty.component';
import { DialogSelectPeriodComponent } from '../../components/dialogs/dialog-select-period/dialog-select-period.component';
import { DialogLiquidacionesComponent } from '../../components/dialogs/dialog-liquidaciones/dialog-liquidaciones.component';
import { DetailsSurveySymptomsComponent } from '../../components/dialogs/details-survey-symptoms/details-survey-symptoms.component';
import { DialogSelectedItemComponent } from '../../components/dialogs/dialog-selected-item/dialog-selected-item.component';
import { DialogCreatePersonInfoCompanyComponent } from '../../components/dialogs/dialog-create-person-info-company/dialog-create-person-info-company.component';
import { DialogChooseEnrollmentMethodComponent } from '../../components/dialogs/dialog-choose-enrollment-method/dialog-choose-enrollment-method.component';
import { DialogEnrolarPersonalWithContractComponent } from '../../components/dialogs/dialog-enrolar-personal-with-contract/dialog-enrolar-personal-with-contract.component';
import { DialogSolicitudDocumentoComponent } from '../../components/dialogs/dialog-solicitud-documento/dialog-solicitud-documento.component';
import { DialogMovePersonalInfoComponent } from '../../components/dialogs/dialog-move-personal-info/dialog-move-personal-info.component';
import { DialogListComponent } from '../../components/dialogs/dialog-list/dialog-list.component';
import { DialogContractListComponent } from '../../components/dialogs/dialog-contract-list/dialog-contract-list.component';
import { DialogCrudSucursalesComponent } from '../../components/dialogs/dialog-crud-sucursales/dialog-crud-sucursales.component';
import { DialogChangeOneFileComponent } from '../../components/dialogs/dialog-change-one-file/dialog-change-one-file.component';
import { PersonalInfoContract } from '../../models/Personal/personalInfoContract';
import { DialogPollComponent } from '../../components/dialogs/dialog-poll/dialog-poll.component';
import { DialogCreateContractComponent } from '../../components/dialogs/dialog-create-contract/dialog-create-contract.component';
import { DialogRequirementsComponent } from '../../components/dialogs/dialog-requirements/dialog-requirements.component';
import { DialogHoursAllowedComponent } from '../../components/dialogs/dialog-hours-allowed/dialog-hours-allowed.component';
import { DialogSelectedControlSearchListComponent } from '../../components/dialogs/dialog-selected-control-search-list/dialog-selected-control-search-list.component';
import { DialogPersonAssociateContractsComponent } from '../../components/dialogs/dialog-person-associate-contracts/dialog-person-associate-contracts.component';
import { DialogMapComponent } from '../../components/dialogs/dialog-map/dialog-map.component';
import { DialogSelectedCausalComponent } from '../../components/dialogs/dialog-selected-causal/dialog-selected-causal.component';
import { DialogUpdatePasswordComponent } from '../../components/dialogs/dialog-update-password/dialog-update-password.component';
import { DialogAdminAccesoPersonalComponent } from '../../components/dialogs/dialog-admin-acceso-personal/dialog-admin-acceso-personal.component';
import { DialogConfirmImgComponent } from '../../components/dialogs/dialog-confirm-img/dialog-confirm-img.component';
import { DialogCRUDPermissionComponent } from '../../components/dialogs/dialog-crudpermission/dialog-crudpermission.component';
import { DialogPerfilesComponent } from '../../components/dialogs/dialog-perfiles/dialog-perfiles.component';
import { DialogCommonOptionsComponent } from '../../components/dialogs/dialog-common-options/dialog-common-options.component';
import {
  DialogRequirementRefenceComponent
} from '../../components/dialogs/dialog-requirement-refence/dialog-requirement-refence.component';
import { DialogEconomicActivityComponent } from '../../components/dialogs/dialog-economic-activity/dialog-economic-activity.component';
import { DialogSecurityReferenceComponent } from '../../components/dialogs/dialog-security-reference/dialog-security-reference.component';
import { DialogFormImageCrudComponent } from '../../components/dialogs/dialog-form-image-crud/dialog-form-image-crud.component';
import { DialogCreateProjectComponent } from '../../components/dialogs/dialog-create-project/dialog-create-project.component';
import { DialogOccupationComponent } from '../../components/dialogs/dialog-occupation/dialog-occupation.component';
import { DialogSocialSecRangeComponent } from '../../components/dialogs/dialog-social-sec-range/dialog-social-sec-range.component';
import { DialogCreateVehicleComponent } from '../../components/dialogs/dialog-create-vehicle/dialog-create-vehicle.component';
import { DialogDocumentCommentInputAndOutputComponent } from '../../components/dialogs/dialog-document-comment-input-and-output/dialog-document-comment-input-and-output.component';
import { DialogSupplyGroupComponent } from '../../components/dialogs/dialog-supply-group/dialog-supply-group.component';
import { DialogSupplyComponent } from '../../components/dialogs/dialog-supply/dialog-supply.component';
import { DialogCarouselComponent } from '../../components/dialogs/dialog-carousel/dialog-carousel.component';
import { DialogSelectDateDisabledComponent } from '../../components/dialogs/dialog-select-date-disabled/dialog-select-date-disabled.component';
import { DialogRequirementEmployerComponent } from '../../components/dialogs/dialog-requirement-employer/dialog-requirement-employer.component';
import { DialogCreateContractLaborComponent } from '../../components/dialogs/dialog-create-contract-labor/dialog-create-contract-labor.component';
import { DialogSelectedVincularContractsComponent } from '../../components/dialogs/dialog-selected-vincular-contracts/dialog-selected-vincular-contracts.component';
import { DialogGestorPlanillasComponent } from '../../components/dialogs/dialog-gestor-planillas/dialog-gestor-planillas.component';
import { DialogPayrollRulesComponent } from '../../components/dialogs/dialog-payroll-rules/dialog-payroll-rules.component';
import { DialogWorkShiftsComponent } from '../../components/dialogs/dialog-work-shifts/dialog-work-shifts.component';
import {
  DialogWorkScheduleCalendarComponent,
  WorkScheduleCalendarDialogData
} from '../../components/dialogs/dialog-work-schedule-calendar/dialog-work-schedule-calendar.component';
import { DialogNoveltyComponent } from '../../components/dialogs/dialog-novelty/dialog-novelty.component';
import { DialogCreateNoveltyDialogComponent } from '../../components/dialogs/dialog-create-novelty-dialog/dialog-create-novelty-dialog.component';
import { DialogCreatePrenominaComponent } from '../../components/dialogs/dialog-create-prenomina/dialog-create-prenomina.component';
import {
  DialogPrenominaHistorialComponent,
  DialogPrenominaHistorialData
} from '../../components/dialogs/dialog-prenomina-historial/dialog-prenomina-historial.component';
import { DialogCreateTerminationComponent } from '../../components/dialogs/dialog-create-termination/dialog-create-termination.component';
import { DialogConfirmCodeLoginComponent } from '../../components/dialogs/dialog-confirm-code-login/dialog-confirm-code-login.component';
import { DialogGestorDocumentsComponent } from '../../components/dialogs/dialog-gestor-documents/dialog-gestor-documents.component';
import { DialogAddPersonalSocialSegurityComponent } from '../../components/dialogs/dialog-add-personal-social-segurity/dialog-add-personal-social-segurity.component';
import {DialogSearchAdminComponent} from '../../components/dialogs/dialog-search-admin/dialog-search-admin.component';
import {
  DialogContractAddProjectComponent
} from '../../components/dialogs/dialog-contract-add-project/dialog-contract-add-project.component';
import {DialogProjectAddComponent} from '../../components/dialogs/dialog-project-add/dialog-project-add.component';
import {
  DialogContractAddTransferPersonnelComponent
} from '../../components/dialogs/dialog-contract-add-transfer-personnel/dialog-contract-add-transfer-personnel.component';
import {DialogCargeMasivoComponent} from '../../components/dialogs/dialog-carge-masivo/dialog-carge-masivo.component';
import {DialogEditMinutesComponent} from '../../components/dialogs/dialog-edit-minutes/dialog-edit-minutes.component';
import {
  DialogGestorImgPersonalComponent
} from '../../components/dialogs/dialog-gestor-img-personal/dialog-gestor-img-personal.component';
import {
  DialogSelectedControlWithdrawalsComponent
} from '../../components/dialogs/dialog-selected-control-withdrawals/dialog-selected-control-withdrawals.component';
import {
  DialogContractNotificationSchedulingComponent
} from '../../components/dialogs/dialog-contract-notification-scheduling/dialog-contract-notification-scheduling.component';
import {DialogSendingReportsComponent} from '../../components/dialogs/dialog-sending-reports/dialog-sending-reports.component';
import {DialogQuestionSettingsComponent} from '../../components/dialogs/dialog-question-settings/dialog-question-settings.component';
import {
  DialogTrainingsEvaluationsHistoricalComponent
} from '../../components/dialogs/dialog-trainings-evaluations-historical/dialog-trainings-evaluations-historical.component';
import {DialogCopyProfileAdmonComponent} from '../../components/dialogs/dialog-copy-profile-admon/dialog-copy-profile-admon.component';
import {
  DialogTermsConditionsPrivacyComponent
} from '../../components/dialogs/dialog-terms-conditions-privacy/dialog-terms-conditions-privacy.component';
import {
  DialogRequirementConfigurationComponent
} from '../../components/dialogs/dialog-requirement-configuration/dialog-requirement-configuration.component';
import {
  DialogPlanillasGestordocumentComponent
} from '../../components/dialogs/dialog-planillas-gestordocument/dialog-planillas-gestordocument.component';
import {
  DialogGestorDocumentsPlanillaslistComponent
} from '../../components/dialogs/dialog-gestor-documents-planillaslist/dialog-gestor-documents-planillaslist.component';
import {
  DialogReferencestypesOvertimeComponent
} from '../../components/dialogs/dialog-referencestypes-overtime/dialog-referencestypes-overtime.component';
import {DialogImgRegisterComponent} from '../../components/dialogs/dialog-img-register/dialog-img-register.component';
import {DialogAnuncioInformativoComponent, DialogAnuncioInformativoData, DialogAnuncioInformativoMode} from '../../components/dialogs/dialog-anuncio-informativo/dialog-anuncio-informativo.component';
import {
  DialogSearchOwnerVehicleComponent
} from '../../components/dialogs/dialog-search-owner-vehicle/dialog-search-owner-vehicle.component';
import {
  DialogAnuncioData,
  DialogAnuncioInformativosGeneralesComponent, DialogAnuncioMode
} from '../../components/dialogs/dialog-anuncio-informativos-generales/dialog-anuncio-informativos-generales.component';
import {
  DialogChangeWorkplaceComponent,
  DialogChangeWorkplaceData
} from '../../components/dialogs/dialog-change-workplace/dialog-change-workplace.component';
import {
  DialogWizardSearchResquestIdComponent
} from '../../components/dialogs/dialog-wizard-search-resquest-id/dialog-wizard-search-resquest-id.component';
import {
  DialogGenerateWithdrawalsReportComponent
} from '../../components/dialogs/dialog-generate-withdrawals-report/dialog-generate-withdrawals-report.component';
import {
  DialogFiltrosMinutaPersonalComponent,
  MinutaPersonalFiltersValue
} from '../../components/dialogs/dialog-filtros-minuta-personal/dialog-filtros-minuta-personal.component';
import { DialogFaceTraceComponent, DialogFaceTraceData } from '../../components/dialogs/dialog-face-trace/dialog-face-trace.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    private dialog: MatDialog) {}

  // Devuelve true si confirma de lo contrario es false
  openDialogConfirm(
    message: string,
    btnConfirm?: boolean,
    btnCancel?: boolean,
    textBtnCancel?: string,
    textBtnConfirm?: string,
    question?: string
  ) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '92vw',
      maxWidth: '460px',
      maxHeight: '90vh',
      panelClass: 'modern-confirm-dialog-panel',
      backdropClass: 'modern-confirm-dialog-backdrop',
      autoFocus: false,
      disableClose: true,
      data: {
        message,
        confirm: false,
        btnConfirm,
        btnCancel,
        textBtnCancel,
        textBtnConfirm,
        question
      }
    });

    return dialogRef;
  }

  openDialogConfirmCodeLogin(email, password) {
    const dialogRef = this.dialog.open(DialogConfirmCodeLoginComponent, {
      width: '452px',
      data: {email, password},
      disableClose: true
    });
    return dialogRef;
  }

  // Devuelve true si confirma de lo contrario es false
  openDialogSelectDateDisabledComponent(message: string, btnConfirm?: boolean, btnCancel?: boolean,
                                        textBtnCancel?: string, textBtnConfirm?: string, question?: string) {
    const dialogRef = this.dialog.open(DialogSelectDateDisabledComponent, {
      width: '452px',
      data: {message, confirm: false, btnConfirm, btnCancel, textBtnCancel, textBtnConfirm, question},
      disableClose: true
    });
    return dialogRef;
  }

  openDialogOk(message: string, buttonText: string, surveySymptoms: SurveySymptomsValidateAds, color: number) {
    const dialogRef = this.dialog.open(DialogOkComponent, {
      width: '452px',
      data: {message, confirm: true, buttonText, surveySymptoms, color },
      disableClose: true
    });
    return dialogRef;
  }

  openDialogImageOrVideoOrPdf(image?: string, video?: string) {
    const dialogRef = this.dialog.open(DialogImageOrVideoComponent, {
      panelClass: 'my-full-screen-dialog',
      data: {image, video}
    });
    return dialogRef;
  }

  openDialogSelectPersonalCompanyInfoId(personalInfo: PersonalInfo[]) {
    const dialogRef = this.dialog.open(DialogSelectPersonalCompanyInfoId, {
      width: '300px',
      data: personalInfo,
      disableClose: true
    });
    return dialogRef;
  }

  openDialogCondiciones(typeDialog: string, companyModel: CompanyModel) {
    const dialogRef = this.dialog.open(DialogCondicionesComponent, {
      width: '352px',
      data: {typeDialog, companyModel},
      disableClose: true
    });
    return dialogRef;
  }

  openDialogPrintPreCarnet(print: string, personalInfo: any) {
    const dialogRef = this.dialog.open(DialogPrintPreCarnetComponent, {
      width: '500px',
      data: {print, personalInfo},
      disableClose: true,
      // panelClass: 'custom-dialog'
    });
    return dialogRef;
  }

  openDialogAdminAcceso(personalContractProyectSelected: any, typeAdmin: TypeAdminAcceso, isCrud?: boolean, Requirements?: number[]) {
    const dialogRef = this.dialog.open(DialogAdminAccesoComponent, {
      width: 'auto',
      data: {personalContractProyectSelected, typeAdmin, isCrud, Requirements},
      disableClose: false,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogAdminAccesoPersonal(personalContractSelected: any, typeAdmin: TypeAdminAcceso, isCrud?: boolean, Requirements?: number[]) {
    const dialogRef = this.dialog.open(DialogAdminAccesoPersonalComponent, {
      width: 'auto',
      data: {personalContractSelected, typeAdmin, isCrud, Requirements},
      disableClose: false,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogRequirements(Requirements: any[], title?) {
    const dialogRef = this.dialog.open(DialogRequirementsComponent, {
      // width: '600px',
      data: {Requirements, title},
      disableClose: false,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogRequirementEmployer(Requirements: any[], title?, adminInfoId?: string | number, byEmployer: boolean = true) {
    const dialogRef = this.dialog.open(DialogRequirementEmployerComponent, {
      width: '450px',
      data: {Requirements, title, adminInfoId, byEmployer},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogGestorImg(title, docs?: ModelDocumentsShow[], typeOperator?: string, idPlanilla?: any,
                      typeGestor?: string, cropper?: boolean, desc?: string, permissionCompany?,
                      isFromPersonal?, companyInfoId?,  requirement?: any, permissions?: string[] ) {
    const dialogRef = this.dialog.open(DialogGestorImgComponent, {
      width: '360px',
      data: {title, docs, typeOperator, idPlanilla, typeGestor, cropper, desc, permissionCompany,
        isFromPersonal, companyInfoId, requirement, permissions },
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogGestorImgPersonal(title, docs?: ModelDocumentsShow[], typeOperator?: string, idPlanilla?: any,
                              typeGestor?: string, cropper?: boolean, desc?: string, permissionCompany?,  companyInfoId?: string,  ) {
      const dialogRef = this.dialog.open(DialogGestorImgPersonalComponent, {
        width: 'auto',
        data: {title, docs, typeOperator, idPlanilla, typeGestor, cropper, desc, permissionCompany, companyInfoId},
        disableClose: true,
        panelClass: 'custom-dialog-transparent'
      });
      return dialogRef;
    }

  openDialogGestorDocuments(title, docs?: any, typeOperator?, module?: string, adminInfoId?, isFromPersonal?) {
    const dialogRef = this.dialog.open(DialogGestorDocumentsComponent, {
      width: '360px',
      data: {title, docs, typeOperator, module, adminInfoId, isFromPersonal},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogGestorDocumentsPlanillaList(title, docs?: any, typeOperator?, module?: string, adminInfoId?,  isFromPersonal?) {
    const dialogRef = this.dialog.open(DialogGestorDocumentsPlanillaslistComponent, {
      width: '360px',
      data: {title, docs, typeOperator, module, adminInfoId, isFromPersonal},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogGestorPlanillas(title, docs?: ModelDocumentsShow[], typeOperator?: string, idPlanilla?: any,
                            typeGestor?: string, cropper?: boolean, desc?: string, proveedorId?: string) {
    const dialogRef = this.dialog.open(DialogGestorPlanillasComponent, {
      width: '360px',
      data: {title, docs, typeOperator, idPlanilla, typeGestor, cropper, desc, proveedorId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogPlanillasGestorDocument(title: string, docs?: ModelDocumentsShow[], typeOperator?: string, idPlanilla?: any,
                                    permissionCompany?: string[], typeGestor?: string, readOnly?: boolean) {
    const dialogRef = this.dialog.open(DialogPlanillasGestordocumentComponent, {
      width: '360px',
      data: {title, docs, typeOperator, idPlanilla, permissionCompany, typeGestor, readOnly},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogDocumentCommentInputAndOutput(title, typeOperator, docs?: ModelDocumentsShow[], desc?: string,
                                          CompanyInfoParentId?: string, EventId?: string) {
    const dialogRef = this.dialog.open(DialogDocumentCommentInputAndOutputComponent, {
      width: '360px',
      data: {title, typeOperator, docs, desc, CompanyInfoParentId, EventId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogChangeOneFile(urlType: string, url?: string, typeOperator?: string, files?: File[],  companyInfoId?: string,  ) {
    const dialogRef = this.dialog.open(DialogChangeOneFileComponent, {
      width: '360px',
      data: {urlType, url, typeOperator, files, companyInfoId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogDialogConfirmImg(title: string, messsage: string[], urlComplet: string, urlAssets: string) {
    const dialogRef = this.dialog.open(DialogConfirmImgComponent, {
      width: '100%',
      data: {title, messsage, urlComplet, urlAssets},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogDialogPayrollRules(title: string, payrollConfiguration: PayrollConfiguration, CompanyInfoId: string) {
    const dialogRef = this.dialog.open(DialogPayrollRulesComponent, {
      width: '100%',
      data: {title, payrollConfiguration, CompanyInfoId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogContratoIndividual(message: string) {
    const dialogRef = this.dialog.open(DialogContratoIndividualComponent, {
      width: '350px',
      data: {message},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogEnrolarPersonalWithContract(CompanyInfoId, IsRequest, isFromPersonalList?, createEmptyPositionOnInit?, maxRequestDays?,
                                        allowRequestsForVisit?) {
    const dialogRef = this.dialog.open(DialogEnrolarPersonalWithContractComponent, {
      width: '92vw',
      maxWidth: '495px',
      maxHeight: '90vh',
      data: {
        CompanyInfoId,
        IsRequest,
        isFromPersonalList,
        createEmptyPositionOnInit,
        maxRequestDays,
        allowRequestsForVisit
      },
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSolicitudDocumento(module: 'Personal' | 'Employer', adminInfoId, isFromPersonal?, isUploadFlow?: boolean) {
    const dialogRef = this.dialog.open(DialogSolicitudDocumentoComponent, {
      width: '92vw',
      maxWidth: '520px',
      maxHeight: '90vh',
      data: { module, adminInfoId, isFromPersonal, isUploadFlow },
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogAddPersonalSocialSegurity(EmployerInfoId) {
    const dialogRef = this.dialog.open(DialogAddPersonalSocialSegurityComponent, {
      width: '350px',
      data: {EmployerInfoId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateTermination(CompanyInfoId, IsRequest) {
    const dialogRef = this.dialog.open(DialogCreateTerminationComponent, {
      width: '350px',
      data: {CompanyInfoId, IsRequest},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreatePrenomina(idEmployer) {
    const dialogRef = this.dialog.open(DialogCreatePrenominaComponent, {
      width: '350px',
      data: {idEmployer},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogPrenominaHistorial(data: DialogPrenominaHistorialData) {
    return this.dialog.open(DialogPrenominaHistorialComponent, {
      width: '600px',
      maxWidth: '95vw',
      data,
      autoFocus: false,
      panelClass: 'dialog-prenomina-historial-panel'
    });
  }

  openDialogDetailsSurveySymptoms(Id: number) {
    const dialogRef = this.dialog.open(DetailsSurveySymptomsComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogList(dataList: any, card: CardList, path: string) {
    const dialogRef = this.dialog.open(DialogListComponent, {
      width: '1130px',
      data: {dataList, card, path},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSelectedVincularContracts(cardOne: CardList, cardTwo: CardList, path: string, dataOne, dataTwo, isModifyRequirements?: boolean) {
    const dialogRef = this.dialog.open(DialogSelectedVincularContractsComponent, {
      width: '1130px',
      data: {cardOne, cardTwo, path, dataOne, dataTwo, isModifyRequirements },
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCarousel(imgs: any) {
    const dialogRef = this.dialog.open(DialogCarouselComponent, {
      // width: '2000px',
      data: {imgs},
      disableClose: true,
      panelClass: 'custom-dialog-transparent',
      maxWidth: '900px',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef;
  }

  openDialogMovePersonalInfo(confirmar: boolean, data?: any, question?: string, isRequest?: boolean,
                             title?: string, isFromVehicle?: boolean) {
    const dialogRef = this.dialog.open(DialogMovePersonalInfoComponent, {
      width: '350px',
      data: {confirmar, data, question, isRequest, title, isFromVehicle},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCRUDPermission(IsPost: boolean, Id: number, Name: string) {
    const dialogRef = this.dialog.open(DialogCRUDPermissionComponent, {
      width: '350px',
      data: {IsPost, Id, Name},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogPerfiles(IdRol: string) {
    const dialogRef = this.dialog.open(DialogPerfilesComponent, {
      width: '450px',
      data: {IdRol},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogWorkShiftsProject(CompanyInfoId: string, ProjectId: string, wShift: WorkShiftConfiguration) {
    const dialogRef = this.dialog.open(DialogWorkShiftsComponent, {
      width: '1120px',
      maxWidth: '96vw',
      maxHeight: '94vh',
      data: {CompanyInfoId, ProjectId, wShift},
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      panelClass: ['custom-dialog-transparent', 'work-shift-dialog']
    });
    return dialogRef;
  }

  openDialogCommonOptions(Id: string) {
    const dialogRef = this.dialog.open(DialogCommonOptionsComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogEconomicActivity(Id: string) {
    const dialogRef = this.dialog.open(DialogEconomicActivityComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSecurityReferences(Id: string) {
    const dialogRef = this.dialog.open(DialogSecurityReferenceComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSupplyGroupC(Id: string) {
    const dialogRef = this.dialog.open(DialogSupplyGroupComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSupply(Id: string, CompanyInfoId?: string) {
    const dialogRef = this.dialog.open(DialogSupplyComponent, {
      width: '350px',
      data: {Id, CompanyInfoId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateVehicle(CompanyInfoId: string) {
    const dialogRef = this.dialog.open(DialogCreateVehicleComponent, {
      width: '92vw',
      maxWidth: '495px',
      maxHeight: '90vh',
      data: {CompanyInfoId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateContractLabor(PersonalCompanyInfoId: string, EmployerId: string, CompanyInfoId: string, companyIdUserLogin?: string) {
    const dialogRef = this.dialog.open(DialogCreateContractLaborComponent, {
      width: '360px',
      data: {PersonalCompanyInfoId, EmployerId, CompanyInfoId, companyIdUserLogin},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSocialSecRange(Id: string) {
    const dialogRef = this.dialog.open(DialogSocialSecRangeComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogJob(Id: string) {
    const dialogRef = this.dialog.open(DialogOccupationComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateProject(Id: string, permissions: any[]) {
    const dialogRef = this.dialog.open(DialogCreateProjectComponent, {
      width: '350px',
      data: {Id, permissions},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogFormImageCrud(Id: string) {
    const dialogRef = this.dialog.open(DialogFormImageCrudComponent, {
      width: '350px',
      data: {Id},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogRequirementRefence(Id: string, companyId?, title?) {
    const dialogRef = this.dialog.open(DialogRequirementRefenceComponent, {
      width: '450px',
      data: {Id, companyId, title},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSelectedItemComponent(dataList: any[], card: CardList, title: string) {
    const dialogRef = this.dialog.open(DialogSelectedItemComponent, {
      width: '350px',
      data: {dataList, card, title},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogPersonAssociateContracts(personalCompanyInfoId: any, data: any, proyects, dataModuleRequest?,
                                     isFromVehicle?: boolean, adminInfoId?, isModifyRequirements?: boolean) {
    const dialogRef = this.dialog.open(DialogPersonAssociateContractsComponent, {
      width: '350px',
      data: {personalCompanyInfoId, data, proyects, dataModuleRequest, isFromVehicle, adminInfoId, isModifyRequirements},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogNovelty(dataList: any, card: CardList, employer: string, motivos) {
    const dialogRef = this.dialog.open(DialogNoveltyComponent, {
      width: '1500px',
      data: {dataList, card, employer, motivos},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSelectPeriod(title, description, maxDate, itemsNumber) {
    const dialogRef = this.dialog.open(DialogSelectPeriodComponent, {
      width: '350px',
      data: {title, description, maxDate, itemsNumber},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogMap(address, GeoFenceJson) {
    const dialogRef = this.dialog.open(DialogMapComponent, {
      width: '80%',
      data: {address, GeoFenceJson},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateNovelty(message: string, employer: any, period, edit: boolean, novelty?) {
    const dialogRef = this.dialog.open(DialogCreateNoveltyComponent, {
      width: '350px',
      data: {message, employer, period, edit, novelty},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateNoveltyDialog(message: string, employer: any, period, edit: boolean, motivos) {
    const dialogRef = this.dialog.open(DialogCreateNoveltyDialogComponent, {
      width: '350px',
      data: {message, employer, period, edit, motivos},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogLiquidaciones(period) {
    const dialogRef = this.dialog.open(DialogLiquidacionesComponent, {
      width: '100%',
      data: {period},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSearchEmployer(message: string, CompanyInfoParentId: any) {
    const dialogRef = this.dialog.open(DialogSearchEmployerComponent, {
      width: '350px',
      data: {message, CompanyInfoParentId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSearchAdmin(message: string) {
    const dialogRef = this.dialog.open( DialogSearchAdminComponent, {
      width: '350px',
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSelectedControlSearchList(optionsCardSelect: OptionsCardSelect, title: string, data: any[],
                                      disableClose: boolean, btnClose: boolean, btnConfirm: boolean, textClose: string, textConfirm: string,
                                      autoClose?: boolean, message?: string, colorMessage?: string) {
    const dialogRef = this.dialog.open(DialogSelectedControlSearchListComponent, {
      width: '350px',
      data: {optionsCardSelect, title, data, btnClose, btnConfirm, textClose, textConfirm, autoClose, message, colorMessage},
      disableClose,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSelectedControlSearchListMassiveUpload(
    optionsCardSelect: OptionsCardSelect,
    title: string,
    data: any[],
    disableClose: boolean,
    btnClose: boolean,
    btnConfirm: boolean,
    textClose: string,
    textConfirm: string,
    autoClose?: boolean,
    message?: string,
    colorMessage?: string
  ) {
    const dialogRef = this.dialog.open(DialogSelectedControlSearchListComponent, {
      width: '440px',
      maxWidth: '92vw',
      maxHeight: '90vh',
      autoFocus: false,
      restoreFocus: true,
      disableClose,
      panelClass: 'massive-upload-dialog-panel',
      data: {
        optionsCardSelect,
        title,
        data,
        btnClose,
        btnConfirm,
        textClose,
        textConfirm,
        autoClose,
        message,
        colorMessage,
        viewMode: 'massiveUpload'
      }
    });

    return dialogRef;
  }

  openDialogSelectedCausal(textClose: string, textConfirm: string, documentType?: string, documentNumber?: string,
                           companyInfoId?: string, employers?,  mode: 'SANCTION' | 'VETO' = 'SANCTION' ) {
    const dialogRef = this.dialog.open(DialogSelectedCausalComponent, {
      width: '360px',
      data: {textClose, textConfirm, documentType, documentNumber, companyInfoId, employers, mode},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateContract(message: string, CompanyInfoParentId: any) {
    const dialogRef = this.dialog.open(DialogCreateContractComponent, {
      width: '350px',
      data: {message, CompanyInfoParentId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogUpdatePassword(userChangeData?, UpdatePasswordAnonymous?) {
    const dialogRef = this.dialog.open(DialogUpdatePasswordComponent, {
      disableClose: true,
      data: {userChangeData, UpdatePasswordAnonymous}
    });
    return dialogRef;
  }

  openDialogIndividualContractAproved(title: string, comment: string, name: string, url?: string, aceptText?: string,
                                      isRechazo?: boolean, isRetiro?: boolean, isAccessDates?: boolean, startDate?: string,
                                      finishDate?: string) {
    const dialogRef = this.dialog.open(DialogIndividualContractAprovedComponent, {
      width: isAccessDates ? '92vw' : '350px',
      maxWidth: isAccessDates ? '460px' : '350px',
      data: {title, comment, name, url, aceptText, isRechazo, isRetiro, isAccessDates, startDate, finishDate},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreatePersonal(data: any, DocumentNumber?: string, DocumentType?: string, personal?: any) {
    const dialogRef = this.dialog.open(DialogCreatePersonalComponent, {
      width: '350px',
      data: {data, DocumentNumber, DocumentType, personal},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreatePersonInfoCompany(FinishDate: string, StartDate: string, id: any, CompanyInfoId: any,
                                    DocumentNumber?: string, DocumentType?: string, personal?: any, IsRequest?: boolean,
                                    typeContract?: string, extractedData?: ExtractedDocumentResponse) {
    const dialogRef = this.dialog.open(DialogCreatePersonInfoCompanyComponent, {
      width: '92vw',
      maxWidth: '640px',
      maxHeight: '90vh',
      data: {FinishDate, StartDate, id, CompanyInfoId, DocumentNumber, DocumentType, personal, IsRequest, typeContract, extractedData},
      disableClose: true,
      autoFocus: false,
      panelClass: 'modern-confirm-dialog-panel',
      backdropClass: 'modern-confirm-dialog-backdrop'
    });
    return dialogRef;
  }

  openDialogChooseEnrollmentMethod(documentType?: string, documentNumber?: string, proyectoId?: string, empresaId?: string,
                                   documentTypeLabel?: string) {
    const dialogRef = this.dialog.open(DialogChooseEnrollmentMethodComponent, {
      width: '92vw',
      maxWidth: '640px',
      maxHeight: '90vh',
      data: {documentType, documentNumber, proyectoId, empresaId, documentTypeLabel},
      disableClose: true,
      autoFocus: false,
      panelClass: 'modern-confirm-dialog-panel',
      backdropClass: 'modern-confirm-dialog-backdrop'
    });
    return dialogRef;
  }

  openDialogDialogCrudSucursales(update: boolean, CompanyId: string, model?: any, daneCity?, isCreate?: boolean) {
    const dialogRef = this.dialog.open(DialogCrudSucursalesComponent, {
      width: '350px',
      data: {update, CompanyId, model, daneCity, isCreate},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCreateEmployer(data: any, DocumentNumber?: string, DocumentType?: string, personal?: any,
                           digito?: any, CompanyInfoParentId?: any) {
    const dialogRef = this.dialog.open(DialogCreateEmployerComponent, {
      width: '350px',
      data: {data, DocumentNumber, DocumentType, personal, digito, CompanyInfoParentId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }


  openDialogListC(dataList: any, path: string) {
    const dialogRef = this.dialog.open(DialogContractListComponent, {
      width: '1130px',
      data: {dataList,  path},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogContractNotificationSchedulingComponent(companyInfoId?: string) {
    const dialogRef = this.dialog.open(DialogContractNotificationSchedulingComponent, {
      width: '350px',
      data: {companyInfoId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogHoursAllowed(minValue, maxValue, arrayWeekDays) {
    const dialogRef = this.dialog.open(DialogHoursAllowedComponent, {
      width: '600px',
      data: {minValue, maxValue, arrayWeekDays},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogContractAddProject(contractId) {
    const dialogRef = this.dialog.open(DialogContractAddProjectComponent, {
      width: '450px',
      data: {contractId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogProjectAdd(projectId) {
    const dialogRef = this.dialog.open(DialogProjectAddComponent, {
      width: '450px',
      data: {projectId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogGeneric(title: string, message: string, btnCancel: string) {
    const dialogRef = this.dialog.open(DialogContractAddTransferPersonnelComponent, {
      width: '450px',
      data: {title, message, btnCancel},
      disableClose: false,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCargeMasivo(title, docs?: any, typeOperator?, module?: string, adminInfoId?, typeToShow?, ssId?) {
    const dialogRef = this.dialog.open(DialogCargeMasivoComponent, {
      width: '450px',
      height: '90vh',
      maxHeight: '90vh',
      data: { title, docs, typeOperator, module, adminInfoId, typeToShow, ssId },
      disableClose: false,
      panelClass: ['custom-dialog-transparent', 'mau-dialog-panel'] // â† array con ambas
    });
    return dialogRef;
  }

  openDialogEditMinutes(supply?){
    const dialogRef = this.dialog.open(DialogEditMinutesComponent, {
      width: '450px',
      data: {supply},
      disableClose: false,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSelectedControlWithdrawal(optionsCardSelect: OptionsCardSelect, title: string, data: any[],
                                      disableClose: boolean, btnClose: boolean, btnConfirm: boolean, textClose: string, textConfirm: string,
                                      autoClose?: boolean, message?: string, colorMessage?: string, endDate?: string) {
    const dialogRef = this.dialog.open(DialogSelectedControlWithdrawalsComponent, {
      width: '350px',
      data: {optionsCardSelect, title, data, btnClose, btnConfirm, textClose, textConfirm, autoClose, message, colorMessage, endDate},
      disableClose,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogTrainingConfigurationForm(title: string, btnConfirm?: boolean, btnCancel?: boolean, idTraining?: number, data?: any) {
    const dialogRef = this.dialog.open(DialogQuestionSettingsComponent, {
      width: '450px',
      data: {title, data, btnConfirm, btnCancel, idTraining},
      disableClose: false,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogSendingReports(idEmployer: string) {
    const dialogRef = this.dialog.open(DialogSendingReportsComponent, {
      width: '450px',
      data: {idEmployer},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogTrainingsEvaluationsHistorical(evaluationId: number, EmployerName: string, approvalPercentage: number) {
    const dialogRef = this.dialog.open(DialogTrainingsEvaluationsHistoricalComponent, {
      width: '350px',
      data: {evaluationId, EmployerName, approvalPercentage},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogCopyProfileAdmon() {
    const dialogRef = this.dialog.open(DialogCopyProfileAdmonComponent , {
      width: '450px',
      data: {},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogTermsConditionsPrivacy(title: string, content: string) {
    const dialogRef = this.dialog.open(DialogTermsConditionsPrivacyComponent , {
      width: '580px',
      data: { title, content },
      disableClose: true,
      autoFocus: false,
      position: {
        top: '24px'
      }
    });
    return dialogRef;
  }

  openDialogRequirementConfiguration(requirementId: string, configuredData?, adminInfoId?: string) {
    const dialogRef = this.dialog.open(DialogRequirementConfigurationComponent, {
      width: '450px',
      data: {
        Id: requirementId,
        requirementId,
        companyId: adminInfoId,
        adminInfoId,
        configurations: configuredData
      },
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogReferencestypesOvertime(companyId: string) {
    const dialogRef = this.dialog.open(DialogReferencestypesOvertimeComponent, {
      width: '450px',
      data: {
        companyId
      },
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogImgRegister(title, docs?: ModelDocumentsShow[], typeOperator?: string, idPlanilla?: any,
                        typeGestor?: string, cropper?: boolean, desc?: string, permissionCompany?,
                        isFromPersonal?, companyInfoId?,  requirement?: any ) {
    const dialogRef = this.dialog.open(DialogImgRegisterComponent, {
      width: '90vw',
      maxWidth: '400px',
      data: {title, docs, typeOperator, idPlanilla, typeGestor, cropper, desc, permissionCompany,
        isFromPersonal, companyInfoId, requirement },
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogAnunciosInformativos(item: any, company: CompanyModel, options?: { mode?: DialogAnuncioInformativoMode; title?: string;
    maxExtraHoursPerPeriod?: number; selectedDays?: number[]; employerInfoId?: string; readOnly?: boolean; personalRow?: any; width?: string;
    periodType?: number | null; creationStartDate?: string | Date | null; isCreationEnabled?: boolean;
    closingBusinessDays?: number | null; isClosingEnabled?: boolean; periodState?: 'OPEN' | 'CLOSED' | null }) {
    const isReprg = options?.mode === 'REPROGRAMACION';
    const isPayrollConfig = options?.mode === 'PAYROLL_CONFIG';
    const dialogRef = this.dialog.open(DialogAnuncioInformativoComponent, {
      width: options?.width ?? (isReprg ? '600px' : isPayrollConfig ? '580px' : '450px'),
      maxWidth: (isReprg || isPayrollConfig) ? '95vw' : '98vw',
      maxHeight: (isReprg || isPayrollConfig) ? '95vh' : undefined,
      data: {
        item,
        company,
        mode: options?.mode ?? 'PRENOMINA',
        title: options?.title,
        maxExtraHoursPerPeriod: options?.maxExtraHoursPerPeriod,
        selectedDays: options?.selectedDays,
        employerInfoId: options?.employerInfoId,
        readOnly: options?.readOnly ?? false,
        personalRow: options?.personalRow,
        periodType: options?.periodType,
        creationStartDate: options?.creationStartDate,
        isCreationEnabled: options?.isCreationEnabled,
        closingBusinessDays: options?.closingBusinessDays,
        isClosingEnabled: options?.isClosingEnabled,
        periodState: options?.periodState
      } as DialogAnuncioInformativoData,
      disableClose: true,
      panelClass: isReprg ? ['custom-dialog-transparent', 'reprog-dialog']
        : isPayrollConfig ? ['custom-dialog-transparent', 'payroll-config-dialog']
        : 'custom-dialog-transparent',
      backdropClass: (isReprg || isPayrollConfig) ? 'modern-confirm-dialog-backdrop' : undefined
    });
    return dialogRef;
  }

  openDialogWorkScheduleCalendar(data: WorkScheduleCalendarDialogData) {
    return this.dialog.open(DialogWorkScheduleCalendarComponent, {
      data,
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      panelClass: ['work-schedule-calendar-dialog']
    });
  }

  openDialogWizardSearchResquestId(
    optionsCardSelect: OptionsCardSelect,
    title: string,
    data: any[],
    disableClose: boolean,
    adminId?: string,
    selectedJobTypeId?: string | null,
    groupSelections?: Array<{ groupId: any; optionId: any }> | null
  ) {
    return this.dialog.open(DialogWizardSearchResquestIdComponent, {
      width: '420px',
      data: { optionsCardSelect, title, data, adminId, selectedJobTypeId, groupSelections },
      disableClose,
      panelClass: 'custom-dialog-transparent'
    });
  }

  openDialogSearchOwnerVehicle(message: string, CompanyInfoParentId: any, currentOwner?: any, vehicleContractId?: string) {
    const dialogRef = this.dialog.open(DialogSearchOwnerVehicleComponent, {
      width: '350px',
      data: {message, CompanyInfoParentId, currentOwner, vehicleContractId},
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogAnunciosInformativosGenerales(mode: DialogAnuncioMode, item?: any, company?: CompanyModel) {
    const isTerminateProject = mode === 'TERMINATE_PROJECT' || mode === 'TERMINATE_EMPLOYER_CONTRACTS';

    return this.dialog.open(
      DialogAnuncioInformativosGeneralesComponent,
      {width: isTerminateProject ? '438px' : '450px', maxWidth: isTerminateProject ? 'calc(100vw - 16px)' : '90vw',
        data: {
          mode,
          item,
          company} as DialogAnuncioData,
        disableClose: true,
        panelClass: isTerminateProject
          ? [
            'custom-dialog-transparent',
            'terminate-project-dialog-panel'
          ]
          : [
            'custom-dialog-transparent'
          ]
      }
    );
  }

  openDialogChangeWorkplace(data: DialogChangeWorkplaceData) {
    const dialogRef = this.dialog.open(DialogChangeWorkplaceComponent, {
      width: '1050px',
      maxWidth: '95vw',
      data,
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }

  openDialogGenerateWithdrawalsReportComponent(terminationDocumentId: number, fileName?: string): void {
    this.dialog.open(DialogGenerateWithdrawalsReportComponent, {
      width: '96vw',
      maxWidth: '1180px',
      maxHeight: '92vh',
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'gw-dialog-panel',
      data: {
        terminationDocumentId,
        fileName
      }
    });
  }

  openDialogWorkScheduleBulk(data: DialogWorkScheduleBulkData) {
    const dialogRef = this.dialog.open(DialogWorkScheduleBulkComponent, {
      data,
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      panelClass: ['work-schedule-bulk-dialog']
    });
    return dialogRef;
  }

  openDialogRepeatPattern(data: DialogRepeatPatternData) {
    return this.dialog.open(DialogRepeatPatternComponent, {
      width: '420px',
      maxWidth: '95vw',
      data,
      disableClose: false,
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'repeat-pattern-dialog',
      backdropClass: 'modern-confirm-dialog-backdrop'
    });
  }

  /** Asignar una rotación (patrón catorcenal) a una persona, o terminar la vigente. */
  openDialogAssignRotation(data: DialogAssignRotationData) {
    return this.dialog.open(DialogAssignRotationComponent, {
      width: '440px',
      maxWidth: '95vw',
      data,
      disableClose: false,
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'assign-rotation-dialog',
      backdropClass: 'modern-confirm-dialog-backdrop'
    });
  }

  openDialogFiltrosMinutaPersonal(rows: any[], currentFilters?: Partial<MinutaPersonalFiltersValue>) {
    const dialogRef = this.dialog.open(DialogFiltrosMinutaPersonalComponent, {
      width: '560px',
      maxWidth: '94vw',
      maxHeight: '90vh',
      disableClose: false,
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'fp-dialog-panel',
      data: { rows, currentFilters }
    });
    return dialogRef;
  }
  openDialogFaceTrace(data: DialogFaceTraceData) {
    const dialogRef = this.dialog.open(DialogFaceTraceComponent, {
      width: '100%',
      maxWidth: '900px',
      data,
      disableClose: true,
      panelClass: 'custom-dialog-transparent'
    });
    return dialogRef;
  }
}

